import { render } from "./AppointmentCard.vue?vue&type=template&id=b82de910"
import script from "./AppointmentCard.vue?vue&type=script&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&lang=js"

import "./AppointmentCard.vue?vue&type=style&index=0&id=b82de910&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__